import xhr from "xhr";

export default async function getProgram(data) {
  const res = await xhr(`/program-types?filters[slug][$eq]=${data.type}`);

  return res.data.data;
}
